import { Box } from '@cbhq/cds-web/layout/Box';
import { HStack } from '@cbhq/cds-web/layout/HStack';
import { VStack } from '@cbhq/cds-web/layout/VStack';
import { Text } from '@cbhq/cds-web/typography/Text';
import { defineMessages, useIntl } from '@cbhq/i18n';

import type { ApprovalRuleRowProps } from './ApprovalRuleRow';
import {
  APPROVAL_RULE_ROW_GAP,
  ApprovalRuleRow,
  APPROVER_COL_WIDTH,
  REQUIREMENT_COL_WIDTH,
  RULE_NAME_COL_WIDTH,
} from './ApprovalRuleRow';

const messages = defineMessages({
  approverColumnLabel: {
    id: 'Security.approvalProductSection.approverColumnLabel',
    defaultMessage: 'Approver',
    description: 'Column header for the approver select in the approval rules table',
  },
  requirementColumnLabel: {
    id: 'Security.approvalProductSection.requirementColumnLabel',
    defaultMessage: 'Requirement',
    description: 'Column header for the required approval count select in the approval rules table',
  },
});

export type ApprovalProductRule = ApprovalRuleRowProps & { id: string };

export type ApprovalProductSectionProps = {
  productName: string;
  rules: ApprovalProductRule[];
  showColumnHeaders?: boolean;
};

export function ApprovalProductSection({
  productName,
  rules,
  showColumnHeaders = false,
}: ApprovalProductSectionProps) {
  const { formatMessage } = useIntl();

  return (
    <VStack gap={3} width="100%" testID="approval-product-section">
      <HStack alignItems="center" gap={APPROVAL_RULE_ROW_GAP} width="100%">
        <Box width={RULE_NAME_COL_WIDTH}>
          <Text font="headline">{productName}</Text>
        </Box>

        <Box width={APPROVER_COL_WIDTH}>
          {showColumnHeaders ? (
            <Text font="label1" color="fgMuted">
              {formatMessage(messages.approverColumnLabel)}
            </Text>
          ) : null}
        </Box>

        <Box width={REQUIREMENT_COL_WIDTH}>
          {showColumnHeaders ? (
            <Text font="label1" color="fgMuted">
              {formatMessage(messages.requirementColumnLabel)}
            </Text>
          ) : null}
        </Box>

        <Box flexGrow={1} />
      </HStack>

      <VStack gap={3} width="100%">
        {rules.map(({ id, ...rule }) => (
          <ApprovalRuleRow key={id} {...rule} />
        ))}
      </VStack>
    </VStack>
  );
}
